import dayjs from 'dayjs';
import { PostEquipment } from '../interfaces/api_equipment.interfaces';
import { FORMAT_DATE_API } from '@umanforge/common';

export const DEFAULT_POST_EQUIPMENT: PostEquipment = {
  sectorId: '',
  name: '',
  description: '',
  expirationDate: dayjs().add( 1, 'days' ).startOf( 'day' ).format( FORMAT_DATE_API ),
  abilitiesId: [],
  skills: []
};